// extracted by mini-css-extract-plugin
export var applicationForm = "Application-module--applicationForm--7e981";
export var courses = "Application-module--courses--45caa";
export var coursesWrapper = "Application-module--coursesWrapper--e34e4";
export var formSubmit = "Application-module--formSubmit--c6de6";
export var holder = "Application-module--holder--22963";
export var info = "Application-module--info--50b05";
export var location = "Application-module--location--41a1b";
export var locationCity = "Application-module--locationCity--9a664";
export var message = "Application-module--message--c181e";
export var messageWrapper = "Application-module--messageWrapper--a1d6b";
export var schedule = "Application-module--schedule--12e93";
export var scheduleWrapper = "Application-module--scheduleWrapper--784be";
export var service = "Application-module--service--b2b92";
export var servicesWrapper = "Application-module--servicesWrapper--07bec";
export var title = "Application-module--title--8b204";
export var trainingStyle = "Application-module--trainingStyle--119a5";
export var wrapper = "Application-module--wrapper--25adc";